import React from 'react';
import { useNavigate } from 'react-router-dom';
import { NetworkBadges } from './NetworkBadges';
import { getNetworkLogoUrl } from '../../utils/helpers';
import '../../css/network-card.css';

export const NetworkCard = ({ network, index, useNameInUrl = false, useCodeInUrl = false }) => {
  const navigate = useNavigate();

  const handleCardClick = (e) => {
    e.preventDefault();

    // Always prefer /n/{subDomain} format if subDomain is available
    if (network.subDomain) {
      // Sanitize the subDomain for URL (replace spaces with hyphens, lowercase)
      const urlSafeSubDomain = network.subDomain.toLowerCase().replace(/\s+/g, '-').replace(/[^\w\-]/g, '');
      navigate('/n/' + urlSafeSubDomain);
    } else {
      // Fallback to businessNetworkID if no subDomain available
      navigate('/network/' + network.businessNetworkID);
    }
  };

  return (
    <div
      className={'card h-100 shadow-sm network-card fade-in stagger-' + (index % 4 + 1)}
      onClick={handleCardClick}
    >
      <div className="card-body network-card-body">
        {/* Logo Header - Full Width */}
        <div className="network-card-logo-container">
          <img
            src={getNetworkLogoUrl(network)}
            alt={network.name}
            className="network-card-logo"
            onError={(e) => { e.target.src = '/logo/image.png'; }}
          />
        </div>

        {/* Card Content */}
        <div className="network-card-content">
          <h5 className="card-title mb-2 network-card-title">
            {network.name}
          </h5>
          <p className="card-text text-muted small mb-2 network-card-description">{network.shortDescription}</p>
          {network.subDomain && (
            <p className="card-text text-muted network-card-code">
              {network.subDomain}
            </p>
          )}
          <NetworkBadges network={network} />
        </div>
      </div>
    </div>
  );
};
